import { setWardsCurrentPageNo } from "pages/AllWards/allWardsSlice";
import { useCallback, useEffect, useState } from "react";
import { TableDatePicker } from "themes/Icon";

import { useDispatch } from "react-redux";
// import { DeleteIcon, EditIcon, TableDatePicker } from "themes/Icon";
import AvatarComp from "themes/elements/Avatar";
import ButtonComp from "themes/elements/Button";
import EmptyState from "themes/elements/EmptyState";
import PaginationComp from "themes/elements/Pagination";
// import { isPermit } from "utils/permissionCheck";
import DateRangePickerComp from "themes/elements/DateRangePickerComp";
import SearchComp from "themes/elements/Search";
import SelectComp from "themes/elements/Select";
import TagComp from "themes/elements/Tag";
import TooltipComp from "themes/elements/Tooltip";
import "../table_comp.scss";

function WardsApprovelTable({
  column,
  data,
  dataClick,
  approve = false,
  // onDeleteAction,
  currentPageNo,
  totalPageNo,
  // handleEdit,
  setSelectedData = () => {},
  isLoading,
  // editAction,
  filterRegion,
  filterWard,
  filterCouncillor,
  filterTerm,
  filterReason,
  filterReqCouncillor,
  filterStatus,
  setIsReject = () => {},
  setIsApprove = () => {},
  setFilterStatus = () => {},
  setFilterReason = () => {},
  setFilterTerm = () => {},
  setFilterRegion = () => {},
  setFilterWard = () => {},
  setFilterCouncillor = () => {},
  setIsDetails = () => {},
  setFilterReqCouncillor = () => {},
}) {
  const [currentPageData, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentPageData(data);
    setSelectedData([]);
  }, [data]);

  const handlePageChange = (page) => {
    dispatch(setWardsCurrentPageNo(page));
  };

  function debounce(func, delay) {
    let timerId;
    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  const handleStatusChange = (value, item) => {
    dispatch(setWardsCurrentPageNo(1));

    setFilterStatus(item);
  };

  const handleSearchChangeDebounced = useCallback(
    debounce((value, type) => {
      dispatch(setWardsCurrentPageNo(1));
      if (type === "region") {
        setFilterRegion(value);
      } else if (type === "ward") {
        setFilterWard(value);
      } else if (type === "reason") {
        setFilterReason(value);
      } else if (type === "councilor") {
        setFilterCouncillor(value);
      } else if (type === "requester") {
        setFilterReqCouncillor(value);
      }
    }, 50),
    []
  ); // 300 ms debounce time

  // This function is what gets called by the event listener
  const handleSearchChange = (event, type) => {
    const value = event.target.value;
    handleSearchChangeDebounced(value, type);
  };

  const SkeletonRow = ({ columns }) => (
    <tr className="table-row">
      {columns.map((col, index) => (
        <td key={index} className="table-data" style={{ width: col.width }}>
          <div className="skeleton-box"></div>
        </td>
      ))}
    </tr>
  );

  const handleCreatedDateChange = (dateString) => {
    dispatch(setWardsCurrentPageNo(1));
    if (dateString) {
      setFilterTerm(dateString);
    } else {
      setFilterTerm(null);
    }
  };

  const clearFilters = () => {
    dispatch(setWardsCurrentPageNo(1));
    setCurrentPageData(data);
    setFilterRegion("");
    setFilterWard("");
    setFilterTerm();
    setFilterCouncillor("");
    setFilterReason();
    setFilterReqCouncillor();
  };

  const onDataClick = (row) => {
    dataClick(row);
  };

  return (
    <div className="table-wrapper">
      <table className="table-comp">
        <thead className="table-head">
          <tr className="table-row">
            {column.map((col, i) => (
              <th
                className="table-header"
                key={i}
                style={{ minWidth: col.width }}
              >
                <span className="flex align-center gap-3">{col.title}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-body">
          <tr className="table-row">
            {column.map((col, i) => (
              <td className="table-data" style={{ width: col.width }} key={i}>
                {col.filter === "searchTitle" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterRegion}
                    onChange={(e) => handleSearchChange(e, "region")}
                  />
                ) : col.filter === "searchCouncillor" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterCouncillor}
                    onChange={(e) => handleSearchChange(e, "councilor")}
                  />
                ) : col.filter === "searchNumber" ? (
                  <SearchComp
                    type="number"
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterWard}
                    onChange={(e) => handleSearchChange(e, "ward")}
                  />
                ) : col.filter === "searchReason" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterReason}
                    onChange={(e) => handleSearchChange(e, "reason")}
                  />
                ) : col.filter === "selectStatus" ? (
                  <SelectComp
                    allowClear={false}
                    value={filterStatus}
                    className="table-select"
                    placeholder={col.placeholder ? col.placeholder : col.title}
                    onChange={handleStatusChange}
                    data={col.dropDown.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    onClear={false}
                  />
                ) : col.filter === "searchRequsted" ? (
                  <SearchComp
                    type="text"
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterReqCouncillor}
                    onChange={(e) => handleSearchChange(e, "requester")}
                  />
                ) : col.filter === "datePicker" ? (
                  <DateRangePickerComp
                    className="table-date-picker"
                    suffixIcon={<TableDatePicker />}
                    onChange={handleCreatedDateChange}
                    value={filterTerm}
                  />
                ) : null}
              </td>
            ))}
          </tr>
          {(filterRegion ||
            filterReason ||
            filterWard ||
            filterCouncillor ||
            filterReqCouncillor ||
            filterTerm) && (
            <div className="clr-btn-container">
              <ButtonComp height={16} variant="link" onClick={clearFilters}>
                Clear filters
              </ButtonComp>
            </div>
          )}
          {!isLoading ? (
            currentPageData?.length > 0 ? (
              currentPageData.map((row) => (
                <tr className="table-row" key={row?.id}>
                  {column.map((col, colIndex) => {
                    return (
                      <td
                        style={{ width: col.width }}
                        className="table-data"
                        key={colIndex}
                      >
                        {col.key === "councillor" && row[col.key] !== null ? (
                          <div className="flex align-center">
                            {row?.councilor_image?.length > 0 &&
                            row[col.key] !== null ? (
                              <AvatarComp
                                shape="square"
                                size={32}
                                blue
                                src={row.councilor_image}
                              />
                            ) : (
                              <AvatarComp size={32} shape="square" blue>
                                {row[col.key]?.replace(" ", "")[0]}
                              </AvatarComp>
                            )}
                            <span
                              className="table-title ml-3"
                              onClick={() => {
                                setIsDetails(true);
                                onDataClick(row);
                              }}
                            >
                              {row[col.key]}
                            </span>
                          </div>
                        ) : col.key === "created_user_name" &&
                          row[col.key] !== null ? (
                          <div
                            className={`flex align-center  ${
                              approve ? "approve" : ""
                            }`}
                          >
                            <div>
                              <div className="created_user_name ">
                                {row?.created_user_image?.length > 0 &&
                                row[col.key] !== null ? (
                                  <AvatarComp
                                    size={32}
                                    blue
                                    src={row.created_user_image}
                                  />
                                ) : (
                                  <AvatarComp size={32} blue>
                                    {row[col.key]?.replace(" ", "")[0]}
                                  </AvatarComp>
                                )}

                                <span
                                  className="table-title ml-3"
                                  onClick={() => {
                                    //
                                    onDataClick(row);
                                  }}
                                >
                                  {row[col.key]}
                                </span>
                              </div>
                              {approve && (
                                <div className="approve-container">
                                  <ButtonComp
                                    wFull
                                    variant="secondary"
                                    className="rejectBtn"
                                    onClick={() => {
                                      onDataClick(row);
                                      setIsReject(true);
                                    }}
                                    height={25}
                                  >
                                    Reject
                                  </ButtonComp>
                                  <ButtonComp
                                    onClick={() => {
                                      onDataClick(row);
                                      setIsApprove(true);
                                    }}
                                    variant="primary"
                                    wFull
                                    className="approveBtn"
                                    height={25}
                                  >
                                    Approve
                                  </ButtonComp>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : col.key === "status" ? (
                          <div>
                            <TagComp
                              className={
                                row?.map_status_flg === 1
                                  ? "ant-tag-green"
                                  : "ant-tag-red"
                              }
                            >
                              {row?.map_status_flg === 1
                                ? "Approved"
                                : "Rejected"}
                            </TagComp>
                          </div>
                        ) : colIndex === 0 ? (
                          // <TooltipComp title={row[col.key]}>
                          <span
                            className="table-title ml-3"
                            onClick={() => {
                              onDataClick(row);
                              setIsDetails(true);
                            }}
                          >
                            {row[col.key]}
                          </span>
                        ) : colIndex === 1 ? (
                          // <TooltipComp title={row[col.key]}>
                          <span
                            className="table-title ml-3"
                            onClick={() => {
                              onDataClick(row);
                              setIsDetails(true);
                            }}
                          >
                            {row[col.key]}
                          </span>
                        ) : (
                          <TooltipComp title={row[col.key]}>
                            <span className=" align-center gap-2 limit-lines">
                              {row[col.key]}
                            </span>
                          </TooltipComp>
                        )}

                        {/* <div className="action-container"> */}
                        {/* {editAction && isPermit(2, "edit") && (
                            <ButtonComp
                              onClick={() => {
                                handleEdit(row);
                              }}
                              height={32}
                              rounded
                            >
                              <EditIcon />
                            </ButtonComp>
                          )} */}
                        {/* {isPermit(2, "delete") && (
                            <ButtonComp
                              onClick={() => {
                                onDeleteAction(row);
                              }}
                              height={32}
                              rounded
                            >
                              <DeleteIcon />
                            </ButtonComp>
                          )} */}
                        {/* </div> */}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <EmptyState />
            )
          ) : (
            Array(10)
              .fill(0)
              .map((_, index) => <SkeletonRow key={index} columns={column} />)
          )}
        </tbody>
      </table>

      <PaginationComp
        isLoading={isLoading}
        currentPageNo={currentPageNo}
        total={totalPageNo}
        onChange={handlePageChange}
      />
    </div>
  );
}

export default WardsApprovelTable;
